import { ReactComponent as Back } from "../../assets/back.svg";
import React, { useEffect, useState } from "react";
import { ReactComponent as ArrowRight } from "../../assets/arrowRight.svg";
import { ReactComponent as ArrowLeft } from "../../assets/arrowLeft.svg";
import { ReactComponent as ReloadIcon } from "../../assets/reload.svg";
import {
  Carousel,
  CarouselApi,
  CarouselContent,
  CarouselItem,
} from "../../components-shadcn/carousel";
import DotInvoice from "../../components/DotInvoice";
import Invoice from "../../components/Invoice";
import PaymentPixAreaCliente from "./PaymentPixAreaCliente";
import PaymentBoletoAreaCliente from "./PaymentBoletoAreaCliente";
import PaymentCreditCardAreaCliente from "./PaymentCreditCardAreaCliente";
import { Toaster } from "../../components-shadcn/sonner";
import { useStore } from "../../lib/store";
import { InvoiceTypes } from "../../lib/interfaces";
import RegisterCard from "./RegisterCard";
import { isMobile } from "react-device-detect";
import axios from "axios";
import { LoadingSpinner } from "../../components/Loading";
import { toast } from "sonner";
import ShareLink from "../../components/ShareLink";
import { AmplitudeLog, handleInstanceAmplitude } from "../../lib/amplitude";

type SituacaoCor = "lightred" | "lightgray" | "lightgreen";

const AreaCliente: React.FC = () => {

  const { set_id_superlogica } = useStore();
  const { set_id_hubspot } = useStore();
  const { set_credit_card } = useStore();
  const { set_external_link, external_link } = useStore();

  const { set_sync_invoices, sync_invoices } = useStore();
  const { set_user } = useStore();

  const params = new URLSearchParams(window.location.search);
  const token_hub = params.get("hb");
  const token_superlogica = params.get("sp");
  const user_id = params.get("user");
  const external_link_param = params.get("el");

  const [meses_invoices, set_meses_invoices]: any = useState();
  const [month_selected, set_month_selected]: any = useState();
  const [selected_invoices, set_selected_invoices]: any = useState();
  const [selected_invoice, set_selected_invoice]: any = useState();
  const [month_index, set_month_index]: any = useState();

  const [request_erros, set_request_erros]: any = useState(false);
  // const [loadStartTime, setLoadStartTime] = useState<number | null>(null);

  const handleClose = () => {
    AmplitudeLog("area_cliente_fechou", {
      user_id: user_id,
      ab_experimento: "variante",
    });
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView?.postMessage("CLOSE");
    }
  };

  function getCorDoMes(faturasMes: InvoiceTypes[]): SituacaoCor {
    if (faturasMes.some((f) => f.situacao === "Atrasada")) {
      return "lightred";
    }
    if (faturasMes.some((f) => f.situacao === "Pendente")) {
      return "lightgray";
    }
    return "lightgreen";
  }

  const getDates = () => {
    const today = new Date();
    const endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    const formattedEndDate = endDate.toISOString().split("T")[0];
    const startDate = new Date(today.getFullYear() - 1, today.getMonth(), 1);
    const formattedStartDate = startDate.toISOString().split("T")[0];
    return { startDate: formattedStartDate, endDate: formattedEndDate };
  };

  const getMonthIndex = (data: Record<string, any[]>, mes: string): number => {
    const keys = Object.keys(data);
    return keys.indexOf(mes);
  };

  const GroupInvoices = (invoices: Array<InvoiceTypes>) => {
    // Função para agrupar
    const groupedInvoices: any = invoices.reduce<Record<string, InvoiceTypes[]>>(
      (acc, invoice) => {
        const key = invoice.mes_referencia;
        if (!acc[key]) acc[key] = [];
        acc[key].push(invoice);
        return acc;
      },
      {}
    );

    set_meses_invoices(Object.values(groupedInvoices));
    const atrasadaOuUltima =
      invoices.find((invoice) => invoice.situacao === "Atrasada") ||
      invoices[invoices.length - 1];

    const faturasMes = invoices.filter(
      (invoice) => invoice.mes_referencia === atrasadaOuUltima?.mes_referencia
    );

    set_month_selected(atrasadaOuUltima.mes_referencia)
    set_selected_invoices(faturasMes)

    set_selected_invoice(faturasMes.find(
      (invoice) => invoice.situacao !== "Pago"
    ));

    set_month_index(getMonthIndex(groupedInvoices, atrasadaOuUltima.mes_referencia))
  }

  const GetStatusCreditCard = async (user_id: number) => {
    try {
      const resposta = await axios.post(
        "https://n8n.kinology.com.br/webhook/get_credit_card",
        {
          id_usuario: user_id.toString()
        },
        {
          headers: {
            "Content-Type": "application/json",
            n8n_token: "81lnrDr5uwvIM3IjGj3vW4r",
          },
        }
      );

      if (resposta.data.status_code === 200) {
        if (resposta.data.card.num_card) {
          set_credit_card(resposta.data.card);
        }
      } else {
        toast("Erro ao carregar cartão de crédito " + resposta.data.status_code + " " + resposta.data.msg, {
          action: {
            label: "X",
            onClick: () => console.log("Undo"),
          },
          className: "!bg-red-dark !text-white-primary",
        });
      }
    } catch (erro: any) {
      toast("Erro ao carregar cartão de crédito " + erro, {
        action: {
          label: "X",
          onClick: () => console.log("Undo"),
        },
        className: "!bg-red-dark !text-white-primary",
      });
    }
  }

  const GetInvoices = async (user_id: number) => {
    let loadStartTime = Date.now();
    try {
      const resposta = await axios.post(
        "https://n8n.kinology.com.br/webhook/get_invoices",
        {
          "id_usuario": user_id.toString(),
          "data_inicio": getDates().startDate,
          "data_fim": getDates().endDate,
          "pagina": 1,
          "limit": 100
        },
        {
          headers: {
            "Content-Type": "application/json",
            n8n_token: "81lnrDr5uwvIM3IjGj3vW4r",
          },
        }
      );
      if (resposta.data.status_code === 200) {
        if (resposta.data.invoices.length > 0) {
          GroupInvoices(resposta.data.invoices);
          const tempoCarregamento = loadStartTime ? Date.now() - loadStartTime : 0;
          AmplitudeLog("area_cliente_visualizou", {
            user_id: user_id,
            ab_experimento: "variante",
            tempo_carregamento: tempoCarregamento,
          });
        } else {
          toast("Nenhuma fatura encontrada", {
            action: {
              label: "X",
              onClick: () => console.log("Undo"),
            },
            className: "!bg-green-dark !text-white-primary",
          });
          set_request_erros(true);
        }
      }
      else {
        toast("Erro ao carregar as faturas: " + resposta.data.status_code + " " + resposta.data.msg, {
          action: {
            label: "X",
            onClick: () => console.log("Undo"),
          },
          className: "!bg-red-dark !text-white-primary",
        });
        set_request_erros(true);
      }
    } catch (erro: any) {
      toast("Erro ao carregar faturas " + erro.message, {
        action: {
          label: "X",
          onClick: () => console.log("Undo"),
        },
        className: "!bg-red-dark !text-white-primary",
      });
    }
  }

  const setMonth = (invoices: Array<InvoiceTypes>) => {
    set_month_selected(invoices[0].mes_referencia);
    set_selected_invoices(invoices);
    set_selected_invoice();
    set_selected_invoice(invoices.find(
      (invoice) => invoice.situacao !== "Pago"
    ));
  }

  useEffect(() => {
    if (token_hub && token_superlogica && user_id && external_link_param && sync_invoices) {
      AmplitudeLog("Area_cliente_pagamento", { user_id: user_id });
      set_id_superlogica(token_superlogica);
      set_id_hubspot(token_hub);
      set_user(user_id);
      set_external_link(external_link_param === "true" ? true : false)
      GetStatusCreditCard(Number(user_id));
      GetInvoices(Number(user_id));
      handleInstanceAmplitude(Number(user_id));
      set_sync_invoices(false);
    }
  }, [sync_invoices]);

  const [api, setApi] = React.useState<CarouselApi>()

  useEffect(() => {
    setTimeout(() => {
      api && api.scrollTo(month_index);
    }, 1000)
  }, [api])

  return (
    <div
      className={`
        px-[2rem]
        pt-[2rem]
        w-[100%]
        h-[100vh]
        bg-white-primary
        rounded-t-[1.5rem]
        ${external_link && !isMobile && 'flex flex-col items-center bg-[#FAFAFA]'}
     `}
    >
      {meses_invoices ?
        <div className={`pb-[2rem] ${external_link && !isMobile && 'w-[60%] bg-[#FFFFFF] p-[2rem] rounded-[1.5rem]  '}`} >
          <div className="flex flex-row justify-between w-[100%]">
            {isMobile &&
              <Back className="w-[1.5rem] h-[1.5rem]" onClick={() => handleClose()} />
            }
            <p className="text-blue-primary text-[1.2rem] font-[700]">
              Área do cliente
            </p>
            <p>
              {external_link === false && isMobile && <ShareLink />}
            </p>
          </div>
          <p className="text-[1.2rem] font-[600] mt-[2.44rem]">
            Faturas
          </p>
          <p className="mt-[0.88rem]">Selecione a fatura desejada</p>
          <Carousel
            setApi={setApi}
            className={`
              w-[100%]
              mt-[1.3rem]
              mb-[2rem]
              ${!isMobile && "ml-[1rem]"}
              ${!isMobile && "w-[90%]"}
            `}
            opts={{ startIndex: 5 }}
          >
            <CarouselContent>
              {meses_invoices?.map((item: Array<InvoiceTypes>, index: number) => (
                <CarouselItem
                  className={
                    `${isMobile ? "basis-1/2" : "basis-1/4"}`
                  }
                  key={item[0].mes_referencia}>
                  <DotInvoice
                    onClick={() => {
                      setMonth(item)
                    }}
                    selected={
                      month_selected === item[0].mes_referencia ? true : false
                    }
                    theme={getCorDoMes(
                      meses_invoices.find(
                        (group: any) =>
                          group[0].mes_referencia === item[0].mes_referencia
                      ) ?? []
                    )}
                    price={
                      meses_invoices
                        ?.find(
                          (group: any) =>
                            group[0].mes_referencia === item[0].mes_referencia
                        ) // encontra o subarray do mês
                        ?.reduce(
                          (acc: any, invoice: any) => Number(acc) + Number(invoice.preco),
                          0
                        ) ?? 0
                    }
                  >
                    {item[0].mes_referencia}
                  </DotInvoice>
                </CarouselItem>
              ))}
            </CarouselContent>
            {!isMobile &&
              <>
                {api?.canScrollNext() &&
                  <button
                    className="absolute left-2 ml-[-2rem] top-1/2 -translate-y-1/2 bg-white rounded-full border-none"
                    data-carousel-prev
                  >
                    <ArrowLeft />
                  </button>
                }
                {api?.canScrollNext() &&
                  <button
                    className="absolute right-2 mr-[-2rem] top-1/2 -translate-y-1/2 bg-white rounded-full border-none"
                    data-carousel-next
                  >
                    <ArrowRight />
                  </button>
                }
              </>
            }
          </Carousel>
          {selected_invoices?.map((item: InvoiceTypes) => (
            <>
              <Invoice
                duedate={item.vencimento}
                nextInvoice={item.proxima_fatura}
                price={item.preco}
                situacao={item.situacao}
                theme={
                  item.situacao === "Pendente" ? "default" :
                    item.situacao === "Pago" ? "green" : "red"}
                selectable={selected_invoices.length > 1 && item.situacao !== "Pago" ? true : false}
                selected={item?.id_fatura === selected_invoice?.id_fatura}
                onClick={() => item.situacao !== "Pago" && set_selected_invoice(item)}
              />
              {selected_invoices.length > 1 &&
                <hr className="mt-[1.5rem] mb-[1.5rem]" />
              }
            </>
          ))}
          <p className="mt-[1.12rem] font-[600] text-gray-dark">Opções de pagamento</p>

          <div className={`flex flex-row gap-[0.5rem] mt-[1.25rem] w-[100%] ${!selected_invoice && 'opacity-50 pointer-events-none'}`}>
            <PaymentCreditCardAreaCliente invoice={selected_invoice}  error={selected_invoices?.[selected_invoices.length - 1].erro} />
            <PaymentPixAreaCliente invoice={selected_invoice} />
            <PaymentBoletoAreaCliente invoice={selected_invoice} />
          </div>

          <p className="mt-[2.25rem] mb-[1rem] font-[600] text-gray-dark">Atalhos</p>
          <div className="mb-[1rem]">
            <RegisterCard error={selected_invoices?.[selected_invoices.length - 1].erro}  />
          </div>
        </div>
        :
        <div className="">
          {isMobile &&
            <Back className="w-[1.5rem] h-[1.5rem]" onClick={() => handleClose()} />
          }
          <div className="flex justify-center items-center h-[100vh]">
            {request_erros ?
              <ReloadIcon onClick={() => { GetInvoices(Number(user_id)); set_request_erros(false) }} className="w-[2rem] h-[2rem]" />
              :
              <LoadingSpinner />
            }
          </div>
        </div>

      }
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 10000,
        }}
      />
    </div>
  );
};

export default AreaCliente;
